import {
    BillingProvider,
    CurrentDossierProvider,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DocumentSignModalProvider,
    DocumentSignModalWrapper,
    DossierDocumentSignProvider,
    DossierDocumentsProvider,
    DossierPrescriberProvider,
    DossierRoutingProvider,
    dossiersBasePath,
} from '@europrocurement/l2d-modules';
import { useFullLayout } from '@europrocurement/flexy-components';

import { Container } from '@mui/material';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ordersBasePath } from '../../../Orders';
import { DetailDossierHeader, DossierBody, DossierPrescriberSyncer } from '../../components';

const DetailDossier: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    const { setPrescriberSwitchDisabled } = useFullLayout();

    if (!idDossier) {
        console.warn(`Dossier non trouvé paramètres url:  ${idDossier}`);
        throw new Error(`Dossier non trouvé paramètres url:  ${idDossier}`);
    }

    useEffect(() => {
        setPrescriberSwitchDisabled(true);
        return () => setPrescriberSwitchDisabled(false);
    }, [setPrescriberSwitchDisabled]);
    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <DocumentPreviewProvider>
                <Container maxWidth="lg">
                    <CurrentDossierProvider
                        autoload
                        idDossier={idDossier}
                    >
                        <DossierPrescriberSyncer />
                        <DocumentSignModalProvider>
                            <DossierDocumentSignProvider>
                                <DossierPrescriberProvider>
                                    <DossierDocumentsProvider
                                        autoload
                                        dossierIds={[idDossier as unknown as string]}
                                    >
                                        <BillingProvider>
                                            <DetailDossierHeader />
                                            <DossierBody />
                                        </BillingProvider>
                                        <DocumentSignModalWrapper />
                                    </DossierDocumentsProvider>
                                </DossierPrescriberProvider>
                            </DossierDocumentSignProvider>
                        </DocumentSignModalProvider>
                    </CurrentDossierProvider>
                </Container>
                <DocumentPreviewOverlay />
            </DocumentPreviewProvider>
        </DossierRoutingProvider>
    );
};

export default DetailDossier;
